export default "__VITE_ASSET__ae0ef2ea__"